import {
    StartPlanningRequest,
    SubmitAnswersRequest,
    SubmitFeedbackRequest,
    EditPlanRequest,
    FinalizePlanRequest
} from 'src/types/planning';
// Note: postCreateDraftQuest lives in src/api/quests/index.ts
import { _callAuthenticatedAPI } from '../apiCaller';

export function postStartPlanning(params: StartPlanningRequest): Promise<any> {
    return _callAuthenticatedAPI(
        'backend/api/v1/quest/plan/start',
        'POST',
        params
    );
}

export function getPlanningSession(sessionId: string): Promise<any> {
    return _callAuthenticatedAPI(`backend/api/v1/quest/plan/${sessionId}`);
}

export function postSubmitAnswers(
    sessionId: string,
    params: SubmitAnswersRequest
): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/answer`,
        'POST',
        params
    );
}

export function postSubmitFeedback(
    sessionId: string,
    params: SubmitFeedbackRequest
): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/feedback`,
        'POST',
        params
    );
}

export function putEditPlan(
    sessionId: string,
    params: EditPlanRequest
): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/edit`,
        'PUT',
        params
    );
}

export function postFinalizePlan(
    sessionId: string,
    params: FinalizePlanRequest
): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/finalize`,
        'POST',
        params
    );
}

export function postRetryPlanning(sessionId: string): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/retry`,
        'POST'
    );
}

/**
 * Hand the rest of a planning Q&A loop to a Beehive contributor.
 * Empty body on success. After this resolves the delegator UI should
 * navigate to ``/overview`` — the session is in ``PROCESSING`` and a
 * contributor work item is queued via ``prepare_task``.
 */
export type OffloadPlanningRequest = {
    priority: number;
    status: number;
    alwaysHumanReview?: boolean;
};

export function postOffloadPlanning(
    sessionId: string,
    params: OffloadPlanningRequest
): Promise<any> {
    return _callAuthenticatedAPI(
        `backend/api/v1/quest/plan/${sessionId}/offload`,
        'POST',
        params
    );
}
